import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Directive, HostBinding, EventEmitter, Input, Output, HostListener, Component, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, Track, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/menu/menu';
import '@fa-switch-sharedservices/web-elements/components/menu-item/menu-item';
import '@fa-switch-sharedservices/web-elements/components/menu-label/menu-label';
import '@fa-switch-sharedservices/web-elements/components/divider/divider';
import '@fa-switch-sharedservices/web-elements/components/menu-item/menu-category';
import '@fa-switch-sharedservices/web-elements/components/menu-item/menu-item-link';
import '@fa-switch-sharedservices/web-elements/components/menu-item/menu-item-checkbox';
import { FadvDividerModule } from '@fa-switch-sharedservices/ng-elements/fadv-divider';

class FadvSubmenuDirective {
    constructor() {
        this.slotName = 'submenu';
    }
}
FadvSubmenuDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSubmenuDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvSubmenuDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvSubmenuDirective, selector: "[fadvSubmenu]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSubmenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fadvSubmenu]',
                }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvMenuItemBaseComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        /* Draws the item in a checked state */
        this.checked = false;
        /* Draws the menu item in a disabled state */
        this.disabled = false;
        /* Unique value to store in the menu item, used to identify menu items when selected */
        this.value = '';
        this.selected = new EventEmitter();
        this.deselected = new EventEmitter();
    }
    handleMenuItemChecked() {
        this.selected.emit(this.value);
    }
    handleMenuItemUnchecked() {
        this.deselected.emit(this.value);
    }
}
FadvMenuItemBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuItemBaseComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive });
FadvMenuItemBaseComponent.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvMenuItemBaseComponent, inputs: { checked: "checked", disabled: "disabled", value: "value" }, outputs: { selected: "selected", deselected: "deselected" }, host: { listeners: { "menu-item-checked": "handleMenuItemChecked()", "menu-item-unchecked": "handleMenuItemUnchecked()" } }, usesInheritance: true, ngImport: i0 });
__decorate([
    Forward()
], FadvMenuItemBaseComponent.prototype, "checked", void 0);
__decorate([
    Forward()
], FadvMenuItemBaseComponent.prototype, "disabled", void 0);
__decorate([
    Forward()
], FadvMenuItemBaseComponent.prototype, "value", void 0);
__decorate([
    Track()
], FadvMenuItemBaseComponent.prototype, "selected", void 0);
__decorate([
    Track()
], FadvMenuItemBaseComponent.prototype, "deselected", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuItemBaseComponent, decorators: [{
            type: Directive
        }], propDecorators: { checked: [{
                type: Input
            }], disabled: [{
                type: Input
            }], value: [{
                type: Input
            }], selected: [{
                type: Output
            }], deselected: [{
                type: Output
            }], handleMenuItemChecked: [{
                type: HostListener,
                args: ['menu-item-checked']
            }], handleMenuItemUnchecked: [{
                type: HostListener,
                args: ['menu-item-unchecked']
            }] } });
class FadvMenuItemLinkComponent extends FadvMenuItemBaseComponent {
}
FadvMenuItemLinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuItemLinkComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvMenuItemLinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvMenuItemLinkComponent, selector: "fadv-menu-item-link", inputs: { checked: "checked", value: "value", disabled: "disabled", href: "href", target: "target", download: "download" }, outputs: { selected: "selected", deselected: "deselected" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvMenuItemLinkComponent.prototype, "href", void 0);
__decorate([
    Forward()
], FadvMenuItemLinkComponent.prototype, "target", void 0);
__decorate([
    Forward()
], FadvMenuItemLinkComponent.prototype, "download", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuItemLinkComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-menu-item-link',
                    template: '<ng-content></ng-content>',
                    inputs: ['checked', 'value', 'disabled'],
                    outputs: ['selected', 'deselected'],
                }]
        }], propDecorators: { href: [{
                type: Input
            }], target: [{
                type: Input
            }], download: [{
                type: Input
            }] } });
class FadvMenuItemCheckboxComponent extends FadvMenuItemBaseComponent {
}
FadvMenuItemCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuItemCheckboxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvMenuItemCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvMenuItemCheckboxComponent, selector: "fadv-menu-item-checkbox", inputs: { checked: "checked", value: "value", disabled: "disabled" }, outputs: { selected: "selected", deselected: "deselected" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuItemCheckboxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-menu-item-checkbox',
                    template: '<ng-content></ng-content>',
                    inputs: ['checked', 'value', 'disabled'],
                    outputs: ['selected', 'deselected'],
                }]
        }] });
class FadvMenuItemComponent extends FadvMenuItemBaseComponent {
}
FadvMenuItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuItemComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvMenuItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvMenuItemComponent, selector: "fadv-menu-item", inputs: { checked: "checked", value: "value", disabled: "disabled" }, outputs: { selected: "selected", deselected: "deselected" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-menu-item',
                    template: '<ng-content></ng-content>',
                    inputs: ['checked', 'value', 'disabled'],
                    outputs: ['selected', 'deselected'],
                }]
        }] });

class FadvMenuCategoryComponent extends FadvMenuItemComponent {
}
FadvMenuCategoryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuCategoryComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvMenuCategoryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvMenuCategoryComponent, selector: "fadv-menu-category", inputs: { label: "label" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvMenuCategoryComponent.prototype, "label", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuCategoryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-menu-category',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { label: [{
                type: Input
            }] } });

class FadvMenuLabelComponent extends FadvBaseComponent {
}
FadvMenuLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuLabelComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvMenuLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvMenuLabelComponent, selector: "fadv-menu-label", usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fadv-menu-label', template: '<ng-content></ng-content>' }]
        }] });

class FadvMenuComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.selected = new EventEmitter();
    }
    typeToSelect(key) {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.typeToSelect(key);
    }
    _handleItemSelected(event) {
        const customEvent = event;
        this.selected.emit(customEvent.detail.item.value);
    }
}
FadvMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvMenuComponent, selector: "fadv-menu", inputs: { orientation: "orientation", scrollable: "scrollable" }, outputs: { selected: "selected" }, host: { listeners: { "sl-select": "_handleItemSelected($event)" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvMenuComponent.prototype, "orientation", void 0);
__decorate([
    Forward()
], FadvMenuComponent.prototype, "scrollable", void 0);
__decorate([
    Track()
], FadvMenuComponent.prototype, "selected", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-menu',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { orientation: [{
                type: Input
            }], scrollable: [{
                type: Input
            }], selected: [{
                type: Output
            }], _handleItemSelected: [{
                type: HostListener,
                args: ['sl-select', ['$event']]
            }] } });

class FadvMenuModule {
}
FadvMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuModule, declarations: [FadvMenuComponent,
        FadvMenuItemComponent,
        FadvMenuLabelComponent,
        FadvMenuCategoryComponent,
        FadvSubmenuDirective,
        FadvMenuItemCheckboxComponent,
        FadvMenuItemLinkComponent], imports: [FadvCommonModule, FadvDividerModule], exports: [FadvMenuComponent,
        FadvMenuItemComponent,
        FadvMenuLabelComponent,
        FadvMenuCategoryComponent,
        FadvSubmenuDirective,
        FadvMenuItemCheckboxComponent,
        FadvMenuItemLinkComponent] });
FadvMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuModule, imports: [FadvCommonModule, FadvDividerModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FadvMenuComponent,
                        FadvMenuItemComponent,
                        FadvMenuLabelComponent,
                        FadvMenuCategoryComponent,
                        FadvSubmenuDirective,
                        FadvMenuItemCheckboxComponent,
                        FadvMenuItemLinkComponent,
                    ],
                    imports: [FadvCommonModule, FadvDividerModule],
                    exports: [
                        FadvMenuComponent,
                        FadvMenuItemComponent,
                        FadvMenuLabelComponent,
                        FadvMenuCategoryComponent,
                        FadvSubmenuDirective,
                        FadvMenuItemCheckboxComponent,
                        FadvMenuItemLinkComponent,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvMenuCategoryComponent, FadvMenuComponent, FadvMenuItemCheckboxComponent, FadvMenuItemComponent, FadvMenuItemLinkComponent, FadvMenuLabelComponent, FadvMenuModule, FadvSubmenuDirective };
